import { HelpOutlineRounded } from '@mui/icons-material'
import { Box, TextField, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { SkillBiteCommitment } from '@emerald-works-nova/content-viewer'
import { useFormContext, Controller } from 'react-hook-form'
import PreviewBox from './preview-box'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../../reducers'

const CommitmentPageBlock = ({ index }) => {
  const { watch, control } = useFormContext()
  const watchBlock = watch(`blocks.${index}`)
  const canEdit = useSelector(SkillBiteEditSlice.selectors.selectEditMode)

  return (
    <Box
      px={3}
      py={2}
      sx={{
        border: '2px solid #EEE',
        borderRadius: '10px'
      }}
    >
      <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
        <Typography sx={{ fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}>Commitment</Typography>
        <Tooltip title='Commitment description here...'>
          <HelpOutlineRounded fontSize='small' htmlColor='#BCBCBC' />
        </Tooltip>
      </Box>
      <Box mt={2}>
        <Typography>Type the commitment label below</Typography>
        <Controller
          name={`blocks.${index}.data.commitmentLabel`}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              error={!!fieldState.error}
              disabled={!canEdit}
              helperText={fieldState.error?.message}
              sx={{ marginTop: '16px', marginBottom: '8px', width: '100%' }}
              label='Commitment Label'
              {...field}
            />
          )}
        />
      </Box>
      {watchBlock?.data && (
        <PreviewBox>
          <SkillBiteCommitment
            block={watchBlock}
            onSaveCommitment={() => new Promise((resolve) => resolve())}
            readOnly
          />
        </PreviewBox>
      )}
    </Box>
  )
}

export default CommitmentPageBlock
